import { Article } from "@mui/icons-material";
import { UserModule } from "types";
import { filterSousMenu } from "menu-items";
import { LINKS } from "utils/constant";

const sousmenus = [
  {
    id: "stocks",
    title: "Articles",
    type: "item",
    url: LINKS.stocks.list,
    caption: "Consulter et gérer les articles",
  },
  {
    id: "magasins",
    title: "Magasins",
    type: "item",
    url: LINKS.magasins.list,
    caption: "Consulter et gérer les magasins",
  },
  {
    id: "approvisionnements",
    title: "Appros",
    type: "item",
    url: LINKS.approvisionnements.list,
    caption: "Consulter et gérer les appros",
  },
  {
    id: "ventes",
    title: "Ventes",
    type: "item",
    url: LINKS.ventes.list,
    caption: "Consulter et gérer les ventes",
  },
  {
    id: "inventaires",
    title: "Inventaires",
    type: "item",
    url: LINKS.inventaires.list,
    caption: "Consulter et gérer les inventaires",
  },
];

export const buildGestionStockMenu = (userModule: UserModule) => {
  const data = filterSousMenu(userModule, sousmenus);

  if (data.length) {
    return {
      id: "group-gestionstocks",
      type: "group",
      children: [
        {
          id: "menu-gestionstock",
          title: "Stocks",
          type: "collapse",
          icon: Article,
          children: data,
        },
      ],
    };
  }
  return null;
};
